import { graphql } from 'gatsby';
import React, { memo } from 'react';

import PageElementGroup from '../components/page-element-group';

export const query = graphql `
	query ImprintPage {
		allPagesJson(filter: {slug: {eq: "imprint"}}) {
			nodes {
				...PageElementGroup
			}
		}
	}
`;

export default memo(
	/**
	 * @param {import("gatsby").PageProps<
	 *   import("../../tmp/graphql-types").ImprintPageQuery,
	 *   {
	 *     hashState: number,
	 *     meta: import("../page-metadata").PageMetadata,
	 *   }
	 * >} props
	 */
	function ImprintPage({data, pageContext: {hashState, meta}}) {
		return (
			<PageElementGroup
				name="main"
				nodes={data.allPagesJson.nodes}
				meta={meta}
				hashState={hashState}
			/>
		);
	}
);
